import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import CartDrawer from '../cart/CartDrawer'
import CartPopup from '../cart/CartPopup'
import { useCartStore } from '../../store/cartStore'

export default function Layout() {
  const { isOpen, toggleCart, popup, hidePopup } = useCartStore()

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      
      {/* Cart Components */}
      <CartDrawer 
        isOpen={isOpen} 
        onClose={toggleCart} 
      />
      
      <CartPopup
        isOpen={popup.isOpen}
        onClose={hidePopup}
        product={popup.product}
        quantity={popup.quantity}
      />
    </div>
  )
}